<template>
    <div>
        <el-form
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="title" label="标题:">
                        <el-input
                            placeholder="请输入标题"
                            v-model="formData.title"
                            size="medium"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="businessType" label="业务:" required>
                        <el-radio-group v-model="formData.businessType" size="medium">
                            <el-radio :label="1">演出</el-radio>
                            <el-radio :label="2">众筹</el-radio>
                            <el-radio :label="3">周边</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item
                        prop="scopeDetail"
                        label="范围:"
                        :rules="{
                            required: formData.scope == 2 ? true : false,
                            message: '请输入ID',
                        }"
                    >
                        <el-radio-group
                            v-model="formData.scope"
                            @change="scopeChange"
                            size="medium"
                        >
                            <el-radio :label="1">所有</el-radio>
                            <el-radio :label="2">部分</el-radio>
                        </el-radio-group>
                        <el-input
                            type="textarea"
                            v-model="formData.scopeDetail"
                            placeholder="多个演出ID/周边ID/众筹ID，以英文逗号分隔"
                            :disabled="formData.scope == 1 ? true : false"
                        ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="noticeType" label="类型:" required>
                        <el-radio-group v-model="formData.noticeType" size="medium">
                            <el-radio :label="1">描述</el-radio>
                            <el-radio :label="2">链接</el-radio>
                        </el-radio-group>
                        <el-input
                            type="textarea"
                            v-model="formData.noticeTypeDetail"
                        ></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="label" label="标签:" required>
                        <el-radio-group v-model="formData.label" size="medium">
                            <el-radio :label="1">公告</el-radio>
                            <el-radio :label="2">直播</el-radio>
                            <el-radio :label="3">活动</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="showModuleArry" label="展示模块:">
                        <el-select v-model="formData.showModuleArry" multiple size="medium">
                            <el-option label="业务详情" value="1"></el-option>
                            <el-option label="已完成订单" value="2"></el-option>
                            <el-option label="待发货订单" value="3"></el-option>
                            <el-option label="已发货订单" value="4"></el-option>
                            <el-option label="候补中订单" value="5"></el-option>
                            <el-option label="已取消订单" value="6"></el-option>
                            <el-option label="退款中订单" value="7"></el-option>
                            <el-option label="已退款订单" value="8"></el-option>
                            <el-option label="已过期订单" value="9"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="40">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item
                        prop="freeOrderShowType"
                        label="免费订单:"
                        required
                    >
                        <el-radio-group v-model="formData.freeOrderShowType" size="medium">
                            <el-radio :label="1">按上述规则展示</el-radio>
                            <el-radio :label="0">不展示上述规则</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button @click="goBack">返回取消</el-button>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >确认提交</el-button
                >
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: [Number, String],
            default: null,
        },
    },
    data() {
        return {
            formData: {
                title: "",
                businessType: 1,
                scope: 1,
                scopeDetail: "",
                noticeType: 1,
                noticeTypeDetail: "",
                label: 1,
                showModuleArry: [],
                showModule: "",
                freeOrderShowType: 1,
            },
            rules: {
                title: [{ required: true, message: "请输入标题" }],
                showModuleArry: [{ required: true, message: "请选择展示模块" }],
            },
            btnLoading: false,
            redirect:
                this.$route.query.redirect || "/operation/businessNotice/list",
        };
    },
    created() {
        if (this.id) {
            this.getDetail();
        }
    },
    methods: {
        // 获取详情
        getDetail() {
            this.$request({
                url: "/business/notice/detail",
                method: "POST",
                params: { id: this.id },
            }).then((res) => {
                //处理成功回调
                const { state, msg, result } = res.data;
                if (state && state == 1 && result) {
                    this.formData = {
                        ...result,
                        showModuleArry: result.showModule
                            .split(",")
                            .filter((v) => v !== ""),
                    };
                } else {
                    return this.$message.error(msg || "获取详情失败");
                }
            });
        },

        //范围切换
        scopeChange(e) {
            if (e == 1) {
                this.formData.scopeDetail = "";
            }
        },

        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.formData.showModule =
                        this.formData.showModuleArry + "";
                    this.$request({
                        url: !this.id
                            ? "/business/notice/create"
                            : "/business/notice/update",
                        method: "POST",
                        data: this.formData,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.goBack();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
        //返回
        goBack() {
            this.$router.push({
                path: this.redirect,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.el-select {
    width: 100%;
}
</style>